import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="bg-web-background text-white text-sm">
            <div className="px-6 sm:px-12 lg:px-24 py-12 lg:py-16">
                <div className="flex flex-col lg:flex-row justify-between gap-12 lg:gap-20">
                    {/* Left */}
                    <div className="flex-1 flex flex-col gap-6">
                        <Link to="/" className="flex items-center gap-3 shrink-0">
                            <img
                                src="/images/whtsappLogo.svg"
                                alt="Company logo"
                            />
                            <span className="text-[18px] font-semibold text-white">
                                Empedance
                            </span>
                        </Link>

                        <p className="max-w-md">
                            Enterprise-grade WhatsApp automation. Built for teams that ship.
                        </p>

                        <div className="flex items-center gap-4">
                            <img src="/images/twitter.svg" alt="Twitter" />
                            <img src="/images/github.svg" alt="GitHub" />
                            <img src="/images/linkedin.svg" alt="LinkedIn" />
                        </div>
                    </div>

                    {/* Right */}
                    <div className="flex-1 flex flex-row gap-10 sm:gap-16 lg:gap-24">
                        {/* Product */}
                        <div className="flex flex-col gap-4 flex-1">
                            <h3 className="font-semibold text-white">Product</h3>

                            <Link to="/" className="text-white/80 hover:text-white">
                                Home
                            </Link>

                            <Link to="/pricing" className="text-white/80 hover:text-white">
                                Pricing
                            </Link>

                            <Link to="/docs" className="text-white/80 hover:text-white">
                                API Docs
                            </Link>
                        </div>

                        {/* Company */}
                        <div className="flex flex-col gap-4 items-start flex-1">
                            <h3 className="font-semibold text-white">Company</h3>

                            <Link to="/contact" className="text-white/80 hover:text-white">
                                Contact
                            </Link>

                            <Link to="/privacy" className="text-white/80 hover:text-white">
                                Privacy
                            </Link>

                            <Link to="/terms" className="text-white/80 hover:text-white">
                                Terms
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10 px-6 sm:px-12 lg:px-24 py-6">
                <p className="text-xs text-white/70">
                    © 2026 Empedance Consultancy Services Pvt. Ltd. All rights reserved.
                </p>
            </div>
        </footer>
    );
}